/**
 * Returns true if a DOM event targeted a button (or anything inside one, such
 * as its icon). Use in AG Grid onRowClicked to keep a row's own navigation
 * from firing when an in-row control (Stop, Force stop, copy) was clicked: the
 * grid's row click is its own event, so React `stopPropagation` on the button
 * cannot prevent it.
 */
export function isButtonClick(event: { event?: Event | null }): boolean {
  const target = event.event?.target;
  if (!(target instanceof Element)) return false;
  return !!target.closest('button');
}
